import { render } from "./trust-data-external-examiner-sign-up-approval.html?vue&type=template&id=46a5073c&scoped=true&ts=true&external"
import script from "./trust-data-external-examiner-sign-up-approval.ts?vue&type=script&lang=ts&external"
export * from "./trust-data-external-examiner-sign-up-approval.ts?vue&type=script&lang=ts&external"

import "./trust-data-external-examiner-sign-up-approval.scss?vue&type=style&index=0&id=46a5073c&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a5073c"]])

export default __exports__